function waitForShadowRoot() {
  // Cerca l'elemento nel DOM
  const element = document.querySelector('#app-embed-container-254471');

  // Verifica se l'elemento esiste
  if (element) {
    const shadowRoot = element.shadowRoot;
    // Una volta trovato l'elemento, crea il MutationObserver
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      button {
         background-color: #011c39 !important;
      }
      button h3 {
        color: var(--main-background) !important;
        font-size: 12px !important;
      }
      button svg {
        fill: var(--main-background) !important;
      }

      p, span, div, h1, h2, h3, btn, label, button {
        font-family: 'PPNeueMontreal', open-sans !important;
      }

      @media only screen and (max-width: 768px) {
        div[data-testid="image"] {
          display: none !important;
        }
        section[data-sizing="form-wrapper"] {
          grid-template-areas: 'content' !important;
          height: 75vh;
        }
      }
    `;
    shadowRoot.appendChild(styleElement);

    // Inizia l'osservazione
  } else {
    // Se l'elemento non esiste, riprova dopo un breve intervallo
    setTimeout(waitForShadowRoot, 500); // Ripeti la verifica ogni 100ms
  }
}

function waitForShadowRootInline() {
  // Cerca l'elemento nel DOM
  const elementInline = document.querySelector('#app-embed');

  // Verifica se l'elemento esiste
  if (elementInline) {
    const shadowRootInline = elementInline.shadowRoot;
    // Una volta trovato l'elemento, crea il MutationObserver
    const styleElementInline = document.createElement('style');
    styleElementInline.textContent = `
      button h3 {
        color: var(--main-background) !important;
        font-size: 12px !important;
      }
      button svg {
        fill: var(--main-background) !important;
      }

      p, span, div, h1, h2, h3, btn, label, button {
        font-family: 'PPNeueMontreal', open-sans !important;
      }
    `;
    shadowRootInline.appendChild(styleElementInline);

    // Inizia l'osservazione
  } else {
    // Se l'elemento non esiste, riprova dopo un breve intervallo
    setTimeout(waitForShadowRootInline, 500); // Ripeti la verifica ogni 100ms
  }
}

// Avvia la funzione
waitForShadowRoot();
waitForShadowRootInline();

document.addEventListener('DOMContentLoaded', () => {
  const announcementBar = document.querySelector('announcement-bar');

  if (announcementBar) {
    let index = 0;
    const content = announcementBar.querySelectorAll('.announcement');
    const length = content.length;

    const slider = announcementBar.querySelector('[data-js-slider]');
    const nextButton = announcementBar.querySelector('.announcement-bar__content-nav--right');
    const prevButton = announcementBar.querySelector('.announcement-bar__content-nav--left');

    let autoplayInterval = null;
    const autoplayDelay = 5000; // 3 seconds

    const startAutoplay = () => {
      autoplayInterval = setInterval(() => {
        if (index < length - 1) {
          index++;
        } else {
          index = 0; // Loop back to the first slide
        }
        updateSlider();
      }, autoplayDelay);
    };

    const stopAutoplay = () => {
      clearInterval(autoplayInterval);
    };

    const resetAutoplay = () => {
      stopAutoplay();
      startAutoplay();
    };

    const updateSlider = () => {
      if (nextButton) nextButton.classList.remove('announcement-bar__content-nav--disabled');
      if (prevButton) prevButton.classList.remove('announcement-bar__content-nav--disabled');

      if (index >= length - 1) {
        index = length - 1;
        if (nextButton) nextButton.classList.add('announcement-bar__content-nav--disabled');
      } else if (index <= 0) {
        index = 0;
        if (prevButton) prevButton.classList.add('announcement-bar__content-nav--disabled');
      }

      slider.scrollTo({
        top: 0,
        left: content[index].offsetLeft,
        behavior: 'smooth'
      });
    };

    // Attach click events to stop and reset autoplay
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        resetAutoplay();
      });
    }
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        resetAutoplay();
      });
    }

    // Start autoplay
    startAutoplay();
  }
});

   // Funzione che ripulisce il testo dei filtri rimuovendo SOLO l'ultimo "(numero)"
  // Esempi:
  // "XS (5)"        → "XS"
  // "50 (L) (12)"   → "50 (L)"
  // "One Size (40)" → "One Size"
  function cleanFacetCounts(root) {
    root = root || document;

    // Tutte le label dei filtri (size, color, availability, ecc.)
    var labels = root.querySelectorAll('.facets__item .facet-checkbox');

    labels.forEach(function (label) {
      // Evitiamo di pulire più volte la stessa label
      if (label.dataset.countCleaned === 'true') return;

      var textNodes = [];
      label.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          textNodes.push(node);
        }
      });

      if (!textNodes.length) return;

      var lastTextNode = textNodes[textNodes.length - 1];
      var original = lastTextNode.textContent;

      // Rimuove SOLO l'ultima parentesi "(123)" alla fine
      var cleaned = original.replace(/\s*\(\d+\)\s*$/, '');

      if (cleaned !== original) {
        lastTextNode.textContent = cleaned;
      }

      // Segno la label come già sistemata
      label.dataset.countCleaned = 'true';
    });
  }

  function initFacetCountCleaner() {
    // Prima pulizia al caricamento iniziale
    cleanFacetCounts();

    // Se il browser non supporta MutationObserver, ci fermiamo qui
    if (!('MutationObserver' in window)) {
      return;
    }

    // Cerchiamo il contenitore dei filtri Shopify
    // 1) facet-filters-form (Dawn e temi OS 2.0)
    // 2) altrimenti il form con id FacetFiltersForm
    // 3) altrimenti una form con classe .facets__form
    var target =
      document.querySelector('facet-filters-form') ||
      document.querySelector('#FacetFiltersForm') ||
      document.querySelector('.facets__form');

    if (!target) return;

    var observer = new MutationObserver(function (mutations) {
      var shouldClean = mutations.some(function (mutation) {
        if (mutation.type !== 'childList') return false;

        // Guardiamo se sono stati aggiunti nodi legati ai filtri
        return Array.from(mutation.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;

          // Se viene inserito un blocco filtri o una parte di esso
          if (node.matches && node.matches('.facets, .facets__form, .facets__item, .facets__disclosure')) {
            return true;
          }

          // Oppure se all'interno c'è almeno una label di filtro
          if (node.querySelector && node.querySelector('.facets__item .facet-checkbox')) {
            return true;
          }

          return false;
        });
      });

      // Se abbiamo rilevato un cambiamento nei filtri, ripuliamo di nuovo
      if (shouldClean) {
        cleanFacetCounts(target);
      }
    });

    // Osserviamo i cambi dentro il contenitore filtri
    observer.observe(target, { childList: true, subtree: true });
  }

  // Avvio su caricamento pagina
  document.addEventListener('DOMContentLoaded', initFacetCountCleaner);